import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditQualification() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/QualificationLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Qualification"
      alert="Qualification Edited Successfully"
      editDataAPIEndPoint={`/Qualification/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/Qualification/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Qualification",
              name: "QL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "QL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        QL_Name: {
          required: true,
          
        },
        QL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditQualification;
